import { call, Effect, takeLatest } from 'redux-saga/effects';

import { types, actions } from 'ducks/supplierEnquiry/settings/general';

import { callApi } from '../../utils';
import * as api from 'api/supplierEnquiry/settings/general';
import { IDataAction } from 'ducks/utils';

function* getSupplierBalancesDetailsDetails(action: IDataAction): IterableIterator<Effect> {
  const { success, failure } = actions.saga.getSupplierGeneralSettings;
  yield callApi(
    call(api.fetch, action.data),
    success,
    failure
  );
}

export default function* rootCustomerSaga(): IterableIterator<Effect> {
  yield takeLatest(types.getSupplierGeneralSettings, getSupplierBalancesDetailsDetails);
}
